export default __webpack_public_path__ + "static/media/not_found.fc5aba62.svg";